export default "__VITE_ASSET__LGDsySOg__"